import * as crypto from 'crypto';

const algorithm = 'aes-256-ctr';
const algPassword = 'd6F3Efeq';

export async function encrypt(text: string) {
  if (text !== null) {
    var cipher = crypto.createCipher(algorithm, algPassword);
    var crypted = cipher.update(text, 'utf8', 'hex');
    crypted += cipher.final('hex');
    return crypted;
  }
  return '';
}

export async function decrypt(text: string) {
  if (text !== null) {
    var decipher = crypto.createDecipher(algorithm, algPassword);
    var dec = decipher.update(text, 'hex', 'utf8');
    dec += decipher.final('utf8');
    return dec;
  }
  return '';
}


// WEBPACK FOOTER //
// ./src/services/crypto-service.ts